export default {
    routes: [
		{
			name: 'tsbx',
			component: () => import('../../view/tsbx/index.vue'),
			meta: {
				title: '报事报修',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/tsindex',
			name: 'tsbx',
			component: () => import('../../view/tsbx/tousuindex.vue'),
			meta: {
				title: '投诉建议',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/tsbx/baoxiu',
			name: 'tsbx',
			component: () => import('../../view/tsbx/baoxiu.vue'),
			meta: {
				title: '报事报修',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/tsbx/tousu',
			name: 'tsbx',
			component: () => import('../../view/tsbx/tousu.vue'),
			meta: {
				title: '投诉建议',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/tsbx/list',
			name: 'tsbx',
			component: () => import('../../view/tsbx/list.vue'),
			meta: {
				title: '历史记录',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/tsbx/pjlist',
			name: 'tsbx',
			component: () => import('../../view/tsbx/pjlist.vue'),
			meta: {
				title: '评价',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/tsbx/bjlist',
			name: 'tsbx',
			component: () => import('../../view/tsbx/bjlist.vue'),
			meta: {
				title: '投诉建议',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/tsbx/zplist',
			name: 'tsbx',
			component: () => import('../../view/tsbx/zplist.vue'),
			meta: {
				title: '报事报修',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/tsbx/wxlist',
			name: 'tsbx',
			component: () => import('../../view/tsbx/wxlist.vue'),
			meta: {
				title: '报事报修',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/tsbx/wxzhlist',
			name: 'tsbx',
			component: () => import('../../view/tsbx/wxzhlist.vue'),
			meta: {
				title: '报事报修',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/tsbx/czlist',
			name: 'tsbx',
			component: () => import('../../view/tsbx/czlist.vue'),
			meta: {
				title: '投诉建议',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},		{
			path: '/tsbx/zhlist',
			name: 'tsbx',
			component: () => import('../../view/tsbx/zhlist.vue'),
			meta: {
				title: '投诉建议',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},{
			path: '/tsbx/gdxq',
			name: 'tsbx',
			component: () => import('../../view/tsbx/gddetail.vue'),
			meta: {
				title: '工单详情',
				head: true,
				headReturn: true,
			}
		},{
			path: '/tsbx/zhgdxq',
			name: 'tsbx',
			component: () => import('../../view/tsbx/zhgddetail.vue'),
			meta: {
				title: '工单详情',
				head: true,
				headReturn: true,
			}
		},
		{
			path: '/tsbx/tswgdet',
			name: 'tsbx',
			component: () => import('../../view/tsbx/tswgdet.vue'),
			meta: {
				title: '投诉建议',
				head: true,
				headReturn: true,
			}
		},
		{
			path: '/tsbx/bxpgdet',
			name: 'tsbx',
			component: () => import('../../view/tsbx/bxpgdet.vue'),
			meta: {
				title: '报事报修',
				head: true,
				headReturn: true,
			}
		},
		{
			path: '/tsbx/bxwgdet',
			name: 'tsbx',
			component: () => import('../../view/tsbx/bxwgdet.vue'),
			meta: {
				title: '报事报修',
				head: true,
				headReturn: true,
			}
		},
		{
			path: '/tsbx/bjxq',
			name: 'tsbx',
			component: () => import('../../view/tsbx/bjdetail.vue'),
			meta: {
				title: '投诉建议',
				head: true,
				headReturn: true,
			}
		},
		{
			path: '/tsbx/wxxq',
			name: 'tsbx',
			component: () => import('../../view/tsbx/wxdetail.vue'),
			meta: {
				title: '报事报修',
				head: true,
				headReturn: true,
			}
		},
		{
			path: '/tsbx/list/xq',
			name: 'tsbx',
			component: () => import('../../view/tsbx/detail.vue'),
			meta: {
				title: '事项详情',
				head: true,
				headReturn: true,
			}
		},{
			path: '/tsbx/tslx',
			name: 'tslx',
			component: () => import('../../view/tsbx/tslx.vue'),
			meta: {
				title: '投诉电话',
				head: true,
				headReturn: true,
			}
		},
	]
}